const isMargiela = document.querySelector('body').getAttribute('data-sitebrand') === "Margiela";
const isMarni = document.querySelector('body').getAttribute('data-sitebrand') === "Marni";
const helpForms = require('./helpForms');
const contactUs = require('../contactUs');
const clientSideValidation = require('./clientSideValidation');
const helpPage = document.querySelector('.help-page');
const fetchUrl = helpPage.dataset.fetchUrl;
const helpMenu = helpPage.querySelector('.help-menu-col');
const urlUtil = require('./urlUtil');
const isMobile = window.innerWidth <= 1024;
const helpMenuLink = isMargiela ? '.sub-menu-list-item a' : '.menu-list-item a';
let primaryAsset;
const setPrimaryAssetValue = () => {
  if(isMargiela) {
    if(isMobile) {
      primaryAsset = helpMenu;
    } else {
      primaryAsset = helpPage.querySelector('.help-content-col .help-content-box');
    }
  } else {
      primaryAsset = helpPage.querySelector('.help-content-col');
  }
}

$(document).ready(function () {
  const aId = helpPage.dataset.helpId;
  let element = document.querySelector(`.page-help-menu .menu-list #${aId}`);
  if (element) {
    element.parentElement.classList.add('active');
  }
  setPrimaryAssetValue();
});

/**
 * Fetches an asset from the server and updates the page accordingly
 * @param {string} assetId the asset id with with to update the page data
 */
function fetchPrimaryAsset(assetId) {
  setPrimaryAssetValue();
  if(!isMargiela || (isMargiela && !isMobile)) {
    const url = urlUtil.getUrlWithNewParameter('cid', assetId, fetchUrl) + '&format=ajax';
    $.get(url, function (data) {
      primaryAsset.innerHTML = data;
      updateCurrentAssetId(assetId);
      clientSideValidation.init();
      clientSideValidation.functions.reAttachNoBubbleEvents();
      $.spinner().stop();
      openSelectedMenuItem();
      const helpDashboardContainer = document.querySelector('#help-dashboard-container');
      if(isMargiela && helpDashboardContainer) {
        helpDashboardContainer.classList.remove('help-dashboard-container');
        helpDashboardContainer.classList.add('page-help-container');
        helpDashboardContainer.querySelector('.help-content-col').classList.remove('help-dashboard-content-col');
      }

      if (isMarni && assetId.indexOf('contact-us') != -1) {
        loadScript('https://cdn.jsdelivr.net/gh/mdbassit/FancySelect@latest/dist/fancyselect.min.js');

        let $contactForm = $('#contact-us-form');
        if (!$contactForm.attr('novalidate')) {
          $contactForm.attr('novalidate', true);
        }

        setTimeout(() => {
          helpForms.onFormInit();
          contactUs.initFaqEvent();
        }, 500);
      }
    });
  }
}

function loadScript(url) {
  document.querySelector('script[src$="'+ url +'"]')  ? document.querySelector('script[src$="'+ url +'"]').remove() : '' ;
  let script = document.createElement('script');
  script.src = url;
  document.body.appendChild(script);
}

$(helpMenu).on('click', helpMenuLink, function (event) {
  if(!isMargiela) {
    const assetId = urlUtil.getParameterByName('content', event.target.href);
    document.querySelectorAll('.menu-list-item').forEach(function (item) {
      return item.classList.remove('active');
    });
    event.target.parentElement.classList.add('active');
    if (!assetId) return;
    $.spinner().start();
      if (assetId != helpPage.dataset.dashboardId) {
      event.preventDefault();
      $.spinner().start();
      fetchPrimaryAsset(assetId);
    }
  } else {
    const assetId = urlUtil.getParameterByName('content', event.target.href);
    if (assetId != helpPage.dataset.dashboardId) {
      !isMobile ? event.preventDefault() : null;
      fetchPrimaryAsset(assetId);
    }
  }
});

/**
 * Hide the main support topics and show back button
 */
function hideTopNav() {
  //document.querySelector('#help-content-col .header').style.display = 'none';
  //document.querySelector('#help-content-col .help-menu-col').style.display = 'none';
  //document.querySelector('#help-content-col .help-content-col').classList.add('inner-column');
  // supportHeadline.classList.add('support_headline_hide');
  // helpMenuBack.classList.add('back_to_help_show');

  // for (const item of topItems) {
  //   item.classList.add('topmenu_hide');
  // }

  // Remove dynamic ajax content
  $(helpPage).find('.js_response-container').remove();
}

/**
 * Hide the main support topics and show the sub menu item which has the current page's content id
 */
function openSelectedMenuItem() {
  hideTopNav();
  const selectedSubMenu = helpMenu.querySelector('#' + helpPage.dataset.helpId);
  if (!selectedSubMenu) {
    return;
  }
  if(!isMargiela) {
    const selectedElementParent = selectedSubMenu.parentElement;
    const highlights = helpMenu.querySelectorAll('.menu-list-item');
    if (!selectedSubMenu) {
      return;
    }
    for (const highlight of highlights) {
      highlight.classList.remove('active');
    }
    // Show selected menu:
    selectedElementParent.classList.add('active');
  } else {
    // select all items and remove active class
    const helpAccordions = document.querySelectorAll('.help-menu-elements .help-menu-item')
    // select all accordions and remove open class
    const helpMenuItems = document.querySelectorAll('.help-menu-elements .help-menu-item .sub-menu-list-item')
      // select inner item to set active
    const selectedHelpMenuItem = selectedSubMenu.closest('.sub-menu-list-item');
    // select accordion to open
    const selectedHelpAccordion = selectedSubMenu.closest('.help-menu-item')

    helpAccordions.forEach(acc => {
      acc.classList.remove('is-visible');
      acc.classList.remove('is-active');
      acc.classList.remove('active');
    });
    helpMenuItems.forEach(item => item.classList.remove('active'));
    if(selectedHelpAccordion) {
      selectedHelpAccordion.classList.add('is-active');
      selectedHelpAccordion.classList.add('is-visible');
      selectedHelpMenuItem.classList.add('active');
    }
  }
}

/**
 * Updates the page data with the given asset id and shows/hides the landing asset.
 * @param {string} assetId the asset id with with to update the page data
 */
function updateCurrentAssetId(assetId) {
  helpPage.dataset.helpId = assetId;

  // if (assetId === landingId) {
  //     primaryAsset.classList.add('d-none');
  //     landingAsset.classList.remove('d-none');
  // } else {
  //     primaryAsset.classList.remove('d-none');
  //     landingAsset.classList.add('d-none');
  // }
  urlUtil.changeCurrentUrlWithParam('content', assetId);
}

if(!isMargiela) {
  document.addEventListener("DOMContentLoaded", function () {
    let stickyElement = document.querySelector(".page-help-menu .menu-list");
    let header = document.querySelector(".header");
    let headerHeight = header ? header.offsetHeight : 0;
    
    if (!stickyElement) return;

    let stickyPosition = stickyElement.getBoundingClientRect().top + window.pageYOffset;

    window.onscroll = function () {
      if (window.pageYOffset > stickyPosition - headerHeight) {
        stickyElement.classList.add("sticky");
        stickyElement.style.top = headerHeight + "px";
      } else {
        stickyElement.classList.remove("sticky");
        stickyElement.style.top = "";
      }
    };
  });

  let menuLinks = document.querySelectorAll(helpMenuLink);

  menuLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  });
}
